<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{(title ? title : (event_type === 'inuse' ? 'fleet_reports.inuse_end_voltage' : 'fleet_reports.charge_end_voltage')) | translate}}
			</h4>
		</div>
	</div>

	<!-- date filter -->
	<div class="row col-xl-7 mb-4" *ngIf="!userParentFilters">
		<div class="col-xl-6 col-md-6">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="minDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-6 col-md-6">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate" [maxDate]="maxDate">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
	</div>

	<div class="row col-xl-7 mb-4" *ngIf="!userParentFilters">
		<div class="col-xl-6 col-md-6" *ngIf="options.hasBatteryOptions">
			<!-- voltage filter -->
			<label for="warning">{{'fleet_reports.battery_voltage' | translate}}</label>
			<ng-select
				[(ngModel)]="selectedBatteryVoltage"
				[items]="batteryVoltagesOptions"
				name="tags_filter"
				bindValue="value"
				bindLabel="label"
				[clearable]="false"
				(ngModelChange)="getEndVoltageChart()"
			></ng-select>
		</div>
		<div class="col-xl-6 col-md-6" *ngIf="options.hasCapacityOptions">
			<!-- capacity filter -->
			<label for="warning">{{'devices.battery_capacity' | translate}}</label>
			<ng-select
				[(ngModel)]="selectedBatteryCapacity"
				[items]="batteryCapacitiesOptions"
				name="tags_filter"
				bindValue="value"
				bindLabel="label"
				[clearable]="false"
				(ngModelChange)="getEndVoltageChart()"
			></ng-select>
		</div>
		<div class="col-xl-6 col-md-6" *ngIf="options.hasTruckTypeOptions">
			<label for="truckType">{{'devices.truck_type' | translate}}</label>
			<ng-select
				[searchable]="false"
				[items]="truckTypeList"
				bindLabel="label"
				bindValue="value"
				placeholder="{{'devices.truck_type' | translate}}"
				[(ngModel)]="selectedEndVoltageTruckTypeFilter"
				(change)="getEndVoltageChart()"
				[clearable]="false"
				[multiple]="false"
			>
			</ng-select>
		</div>
	</div>

	<!-- chart -->
	<!-- totalEventsCount, not voltageChartData.length: the chart always has one row per voltage
	     step, all zeroes when there are no events, so its length never reports "no data" -->
	<div class="row" *ngIf="totalEventsCount && (options.hasTruckTypeOptions || options.hasBatteryOptions); else noData">
		<sct-charts
			id="charge_ah"
			title="{{(event_type === 'inuse' ? 'fleet_reports.inuse_end_voltage' : 'fleet_reports.charge_end_voltage') | translate}}"
			[data]="voltageChartData"
			[columnNames]="chartColumns"
			[options]="chartConfig"
			[type]="'ColumnChart'"
			[height]="500"
		></sct-charts>
	</div>
</div>

<ng-template #noData class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
